import ModelUtil from '@leverege/model-util';
import StringUtil from '@leverege/string-util';
import { createImagineAggregationBuilder } from "../AggregationBuilder.js";
const imagineType = 'range';
const TYPE = `aggregation.${imagineType}`;
const methods = {
  ...ModelUtil.createAllValue('field'),
  ...ModelUtil.createAllValue('keyed'),
  ...ModelUtil.createAllArray('ranges'),
  ...ModelUtil.createAllValue('attrName')
};
function create() {
  return {
    type: TYPE,
    field: null,
    keyed: false,
    ranges: [],
    attrName: null
  };
}
function getValueType(model) {
  return 'buckets';
}
function formatBucketKey(bucket) {
  return `${bucket.from || '*'} - ${bucket.to || '*'}`;
}
export default {
  create,
  TYPE,
  name: StringUtil.camelCaseToTitleCase(imagineType),
  ...methods,
  toImagineAgg: createImagineAggregationBuilder(imagineType),
  getValueType,
  formatBucketKey
};